module.exports = __webpack_public_path__ + "static/img/4.bc8d00eb.webp";